module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Icon/social/instagram_colorful-00626d76ad3877b12a0b72bb1f3753bf.svg";